import { useDispatch, useSelector } from "react-redux";
import RegionSelector from "./index";
import { setRegion } from "../../features/region/regionSlice";
import _ from "lodash";
import Stack from "../shared/Stack";
import { useEffect, useRef, useState } from "react";

function GlobalRegionSelector() {
  const dispatch = useDispatch();
  const [isActive, setIsActive] = useState(false);
  const region = useSelector((state) => state.region.value);
  const voteShareData = useSelector((state) => state.voteShare.value);
  const campaignConfig = useSelector((state) => state.campaignConfig.value);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsActive(false);
      }
    };

    if (isActive) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isActive]);

  if ((campaignConfig.regions || []).length <= 1) {
    return null;
  }
  const currentRegion = campaignConfig.regions.find((r) => r.name === region);
  if (!currentRegion) return null;

  const onRegionSelect = (region) => {
    setIsActive(false);
    dispatch(setRegion(region));
  };

  const possibleRegions = _.chain(voteShareData).map("region").uniq().value();
  const visibleRegions = campaignConfig.regions.filter(
    (region) =>
      possibleRegions.includes(region.name) && region.name !== "NATIONAL",
  );
  const canada = campaignConfig.regions.find(
    (region) =>
      possibleRegions.includes(region.name) && region.name === "NATIONAL",
  );

  return (
    <div
      ref={dropdownRef}
      className={`GlobalRegionSelector dropdown is-right ${isActive ? "is-active" : ""}`}
    >
      <div className="dropdown-trigger">
        <button
          className="button"
          aria-haspopup="true"
          aria-controls="region-menu"
          onClick={() => setIsActive(!isActive)}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            height="24"
            width="24"
          >
            <line
              x1="3"
              y1="6"
              x2="21"
              y2="6"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="6"
              y1="12"
              x2="18"
              y2="12"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
            />
            <line
              x1="9"
              y1="18"
              x2="15"
              y2="18"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
            />
          </svg>
          <span>
            <span className="filter-text">Filter by region: </span>
            <strong>{currentRegion.friendlyName}</strong>
          </span>
        </button>
      </div>
      <div className="dropdown-menu" id="region-menu" role="menu">
        <div className="dropdown-content">
          {canada && (
            <>
              <div
                className={`dropdown-item ${currentRegion.name === canada.name ? "is-active" : ""}`}
                onClick={() => onRegionSelect(canada.name)}
              >
                {canada.friendlyName}
              </div>
              <hr className="dropdown-divider" />
            </>
          )}
          {visibleRegions.map((r) => (
            <div
              className={`dropdown-item ${currentRegion.name === r.name ? "is-active" : ""}`}
              key={r.name}
              onClick={() => onRegionSelect(r.name)}
            >
              {r.friendlyName}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}

export default GlobalRegionSelector;
